/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { ScrollView, Text, TouchableOpacity, View } from 'react-native';
import Icon from '../Icon/Icon';
import { useColors } from '../../hooks/useColors';
import SidebarStyles from './Sidebar.styles';
import { useScale } from '../../hooks/useScale';

interface SidebarProps {
  onClose: () => void;
  title: string;
  onPressRight?: () => void;
  buttonRight?: React.ReactNode | React.ReactNode[];
  children: React.ReactNode | React.ReactNode[];
  action?: React.ReactNode | React.ReactNode[];
  height?: number;
  placement?: 'left' | 'right';
}

const Sidebar: React.FC<SidebarProps> = ({
  onClose,
  title,
  onPressRight,
  buttonRight,
  children,
  action,
  height = 60,
  placement = 'left',
}: SidebarProps) => {
  const styles = SidebarStyles();
  const { colors } = useColors();
  const { scale } = useScale();

  return (
    <View style={[styles.sidebar, { [placement]: 0 }]}>
      <View style={styles.titleContainer}>
        <TouchableOpacity onPress={onClose}>
          <Icon name={'times'} color={colors.text} size={24} />
        </TouchableOpacity>
        <Text style={styles.titleText} numberOfLines={1}>
          {title}
        </Text>
        {!!buttonRight ? (
          <TouchableOpacity onPress={onPressRight}>
            {buttonRight}
          </TouchableOpacity>
        ) : (
          <View style={{ width: 30 }} />
        )}
      </View>
      <ScrollView
        style={styles.scrollContainer}
        contentContainerStyle={styles.content}
        showsVerticalScrollIndicator={false}
      >
        {children}
      </ScrollView>
      {!!action && (
        <View style={[styles.actions, { height: scale(height) }]}>
          {action}
        </View>
      )}
    </View>
  );
};

export default Sidebar;
